import React from "react";
import {
	Box,
	Grid,
	Tooltip,
	TextField as TextFieldMui
} from "@mui/material";
import {
	withStyles
} from "@mui/styles";
import {
	Help as HelpIcon
} from "@mui/icons-material";
import TextField from "./form/TextField";
import CheckboxApi from "./form/CheckboxApi";
import Autocomplete from "./form/Autocomplete";
import AutocompleteCreated from "./form/AutocompleteCreated";
import clsx from "clsx";

class SectionItems extends React.PureComponent {
	_gridXs = (characteristic) => {
		const isViewTemplateSingleText = Boolean(characteristic?.view_template === 'single_text');

		if (characteristic?.is_textarea && !isViewTemplateSingleText) {
			return 12
		}
		if (this.props.name === "Размеры") {
			return 2.4
		}

		return 4
	}

	render () {
		const {
			extraValues,
			characteristicAssignments,
			sectionIndex,
			sectionID,
			isExchangeHash,
			initCharacteristics,

			classes,

			onChange
		} = this.props;
		console.log('start')

		return (
			<Grid container spacing={2}>
				{(characteristicAssignments).map((option, index) => {
					const isMultiple = Boolean(option?.characteristic?.is_multiple);
					const characteristicId = option.characteristic?.id || null;
					const findItem = extraValues[characteristicId];
					let value = Boolean(isMultiple) ? (findItem || []) : findItem;
					const disabled = Boolean(option?.characteristic?.is_readonly || false);
					const isShowOnlyInAdmin = Boolean(option?.characteristic?.show_only_in_admin || false);
					const disabledEdit = Boolean(['length-cm', 'width-cm', 'height-cm', 'depth-cm'].includes(option?.characteristic?.external_id) && isExchangeHash);
					const isHiddenFromSlugs = ['tip-bannera'].includes((option?.characteristic?.slug || ''));

					if (disabled && (value === undefined || value === null || (Array.isArray(value) && value.length <= 0)) || isHiddenFromSlugs) {
						return null
					}
					if (disabled && (option?.characteristic?.decodedVariants || []).length <= 0 && !isShowOnlyInAdmin) {
						return null
					}

					let initValues = initCharacteristics.find((t) => t.slug === option?.characteristic?.slug)?.values || [];
					if (option?.characteristic?.extraDefaultVariant) {
						initValues.push(option?.characteristic?.extraDefaultVariant);
					}

					const isAutocompleteCreated = Boolean(option?.characteristic?.is_float || option?.characteristic?.is_integer);
					const isViewTemplateSingleText = Boolean(option?.characteristic?.view_template === 'single_text');
					const isViewTemplateSingleCheckbox = Boolean(option?.characteristic?.view_template === 'single_checkbox');
					if (Boolean(option?.characteristic?.is_multiple) && value.length > 0) {
						value = value.sort((a, b) => {
							const aSort = initValues.find((t) => Boolean(String(t?.id) === String(a)))?.sort;
							const bSort = initValues.find((t) => Boolean(String(t?.id) === String(b)))?.sort;

							if (aSort < bSort) {
								return 1
							}
							if (aSort > bSort) {
								return -1
							}
							return 0
						});
					}

					return (
						<Grid
							key={`section-${ sectionIndex }-${ index }`}
							item
							xs={this._gridXs(option?.characteristic)}
						>
							<Box className={classes.option}>
								<Box
									className={clsx({
										[classes.optionHead]: true,
										'--hidden': isViewTemplateSingleCheckbox
									})}
								>
									{ option?.characteristic?.name }
									{Boolean(option?.characteristic?.admin_note) && (
										<Tooltip arrow title={<React.Fragment><span dangerouslySetInnerHTML={{ __html: option?.characteristic?.admin_note || "" }}/></React.Fragment>}>
											<HelpIcon color="primary" sx={{fontSize: 20, marginLeft: "4px"}}/>
										</Tooltip>
									)}
								</Box>
								<Box className={classes.optionBody}>
									{Boolean(isViewTemplateSingleCheckbox) && (
										<CheckboxApi
											key={`CheckboxApi-${ characteristicId }`}
											label={option?.characteristic?.name}
											adminNote={option?.characteristic?.admin_note || ""}
											classesOptionHead={classes.optionHead}
											value={String(value || '')}
											initOptions={initValues}
											placeholder="Выберите"
											disabled={disabled || disabledEdit}
											name={characteristicId}
											onChange={onChange}
										/>
									)}
									{Boolean(option?.characteristic?.is_textarea && isViewTemplateSingleText && !isViewTemplateSingleCheckbox) && (
										<TextFieldMui
											value={value}
											name={characteristicId}
											fullWidth
											disabled={disabled || disabledEdit}
											onChange={onChange}
										/>
									)}
									{Boolean(option?.characteristic?.is_textarea && !isViewTemplateSingleText && !isViewTemplateSingleCheckbox) && (
										<TextField
											value={value}
											name={characteristicId}
											disabled={disabled || disabledEdit}
											onChange={onChange}
										/>
									)}
									{Boolean(isAutocompleteCreated && !isViewTemplateSingleCheckbox) && (
										<AutocompleteCreated
											value={value || null}
											initOptions={initValues}
											name={characteristicId}
											postUrl="/admin/api-shop-characteristic-variants"
											postName="characteristic_id"
											disabled={disabled || disabledEdit}
											onChange={onChange}
											characteristic={option?.characteristic}
										/>
									)}
									{Boolean(!option?.characteristic?.is_textarea && !isAutocompleteCreated && !isViewTemplateSingleText && !isViewTemplateSingleCheckbox) && (
										<Autocomplete
											value={Boolean(option?.characteristic?.is_multiple) ? (value || []) : (value || null)}
											initOptions={initValues}
											placeholder="Выберите"
											characteristic={option?.characteristic}
											disabled={disabled || disabledEdit}
											name={characteristicId}
											multiple={isMultiple}
											onChange={onChange}
										/>
									)}
								</Box>
							</Box>
						</Grid>
					)
				})}
			</Grid>
		)
	}
}

const styles = {
	option: {},
	optionHead: {
		display: "flex",
		alignItems: "center",

		fontSize: 16,
		lineHeight: "20px",
		color: "#000000",
		marginBottom: 8,

		"&.--hidden": {
			opacity: 0,
			pointerEvents: "none"
		}
	},
	optionBody: {},
}
SectionItems = withStyles(styles)(SectionItems)

export default SectionItems
